import Head from 'next/head';

import { useMetadata } from '../store/hooks/metadata';

export function Seo() {
  const metadata = useMetadata();

  if (!metadata || !metadata.title) {
    return null;
  }

  return (
    <Head>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata?.description} />
      {metadata.schema ? (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(metadata.schema) }} />
      ) : null}
    </Head>
  );
}
